export default function Container({classes,children}){
    return <div className={classes}>{children}</div>
}